import * as S from './style';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

const Col = ({ w = [], children, ...props }) => (
  <S.Col c1={w[0]} c2={w[1]} c3={w[2]} {...props}>
    {children}
  </S.Col>
);

const Row = forwardRef(({ jc, jcT, jcM, children, inner, ...props }, ref) => (
  <div>
    <S.Row jc={jc} jcT={jcT} jcM={jcM} inner={inner} ref={ref} {...props}>
      {children}
    </S.Row>
  </div>
));

Row.propTypes = {
  jc: PropTypes.oneOf(['flex-start', 'flex-end', 'center']),
};

export { Row, Col };
